@if (getStatusIcon()) {
  <span style="margin-right: 5px"><mat-icon [ngStyle]="getStatusIconColor()">{{
  getStatusIcon() }}</mat-icon></span>
}